import { LOCAL_API_URL,http } from "@/api/base";
import { getActiveConnection, waitForConnection } from "./websocket";
//const api_post_new_chat_url = `${LOCAL_API_URL}/chat/clear`;
//const api_post_stop_chat_url =`${LOCAL_API_URL}/chat/stop`;
//const api_get_history_url =`${LOCAL_API_URL}/chat/history`;

export async function newThread(workspaceSlug) {
  console.log("创建新聊天会话", workspaceSlug);
  console.log(LOCAL_API_URL)
  try {
    const response = await http.post(
      `/public/chat/new_thread/${workspaceSlug}`,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw new Error(
      (error && error.response && error.response.data && error.response.data.message) ||
      (error && error.message) ||
      '网络错误，请稍后重试'
    );
  }
}

export async function saveTestInfo(workspaceSlug, threadSlug, tenantId, username) {
  console.log("保存测试信息", workspaceSlug, threadSlug, tenantId, username);
  try {
    const response = await http.post(
      `/public/chat/save_test_info/${workspaceSlug}?thread_slug=${threadSlug}`,      
      null, 
      {
        headers: { 'Content-Type': 'application/json',
                   'X-tenant-Id': tenantId, // 添加企业ID头           
                   'X-User-Name': username   // 添加用户头

         }
      }
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw new Error(
      (error && error.response && error.response.data && error.response.data.message) ||
      (error && error.message) ||
      '网络错误，请稍后重试'
    );
  }
}
    // 发送流式聊天请求
    export async function sendStreamChatRequest(requestData) {
      console.log("发送流式聊天请求:", requestData);
      const threadSlug = requestData.threadSlug;

      try {
        // 1. 等待连接就绪
        console.log(`[${threadSlug}] 等待连接就绪...`);
        await waitForConnection(threadSlug, 3000); // 3秒超时
        console.log(`[${threadSlug}] 连接已就绪`);

        // 2. 获取连接并发送消息
        const conn = getActiveConnection(threadSlug);
        if (!conn) {
          throw new Error(`[${threadSlug}] 连接不存在`);
        }
        // 3. ⭐重要：清空之前的回复内容
        conn.replyContent = "";
        console.log(`[${threadSlug}] 已清空历史回复内容`);

        // 4. 发送新消息
        const payloadString = JSON.stringify(requestData);
        console.log("发送消息:", payloadString);

        conn.socket.send(payloadString);
        conn.lastActivity = Date.now();
        console.log("消息发送成功");

      } catch (error) {
        console.error("发送消息失败:", error);
        throw error;
      }
    }

//  文件上传辅助方法

// 将文件转换为Base64
/*
async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// 获取所有已上传文件
async function getUploadedFiles() {
  const files = document.getElementById("file-upload").files;
  return Promise.all(
    Array.from(files).map(async file => ({
      name: file.name,
      type: file.type,
      contentString: await fileToBase64(file)
    }))
  );
}*/